'use strict';

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.initialise = function () {
  var someImages = document.querySelectorAll('.js-object-fit');
  setTimeout(function () {
    (0, _objectFitImages2.default)(someImages, { watchMQ: true });
  }, 100);
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/init-object-fit-polyfill.js